import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, ShieldCheck } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export default function Footer() {
    return (
        <footer className="bg-navy text-white" data-testid="site-footer">
            <div className="container-x py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div className="md:col-span-1">
                    <Link to="/" className="inline-block bg-white rounded-md p-3">
                        <img
                            src={BUSINESS.logo}
                            alt="GTA Secure Inc."
                            className="h-20 md:h-24 w-auto max-w-[320px] object-contain"
                        />
                    </Link>
                    <p className="mt-5 text-white/70 text-sm leading-relaxed">
                        Proudly Canadian-owned. Based in Georgetown, Ontario. Serving
                        homeowners and businesses across the Greater Toronto Area with
                        professional security and window solutions.
                    </p>
                </div>

                <div>
                    <h4 className="text-gold font-semibold tracking-wide text-sm uppercase mb-4">
                        Services
                    </h4>
                    <ul className="space-y-2.5 text-sm text-white/80">
                        <li><Link to="/security-films/residential" className="hover:text-gold">Residential Window Films</Link></li>
                        <li><Link to="/security-films/commercial" className="hover:text-gold">Commercial Window Films</Link></li>
                        <li><Link to="/security-cameras" className="hover:text-gold">Security Cameras</Link></li>
                        <li><Link to="/blinds-shutters" className="hover:text-gold">Blinds &amp; Shutters</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-gold font-semibold tracking-wide text-sm uppercase mb-4">
                        Company
                    </h4>
                    <ul className="space-y-2.5 text-sm text-white/80">
                        <li><Link to="/about" className="hover:text-gold">About Us</Link></li>
                        <li><Link to="/contact" className="hover:text-gold">Contact Us</Link></li>
                        <li className="inline-flex items-center gap-2 text-white/60">
                            <ShieldCheck className="h-4 w-4 text-gold" />
                            Licensed & Insured
                        </li>
                    </ul>
                </div>

                <div>
                    <h4 className="text-gold font-semibold tracking-wide text-sm uppercase mb-4">
                        Get in touch
                    </h4>
                    <ul className="space-y-3 text-sm text-white/80">
                        <li className="flex items-center gap-3">
                            <Phone className="h-4 w-4 text-gold" />
                            <a
                                data-testid="footer-phone-link"
                                href={BUSINESS.phoneHref}
                                className="hover:text-gold"
                            >
                                {BUSINESS.phone}
                            </a>
                        </li>
                        <li className="flex items-center gap-3">
                            <Mail className="h-4 w-4 text-gold" />
                            <a
                                href={`mailto:${BUSINESS.email}`}
                                className="hover:text-gold"
                            >
                                {BUSINESS.email}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="container-x py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-white/50">
                    <p>© {new Date().getFullYear()} GTA Secure Inc. All rights reserved.</p>
                    <p>Proudly serving the Greater Toronto Area.</p>
                </div>
            </div>
        </footer>
    );
}
